<div class="container">
  <div class="heading_align">
    <div class="heading">Terms & Conditions of Use <span class="font_14 font_normal"> - for Synappx™</span></div>
  </div>

  <div mat-dialog-content>
    @if (!showSCPToU) {
      <div mat-dialog-content>
        <div class="eula_points"><b>EFFECTIVE: 25/04/2023</b></div>
        <div class="eula_points">
          The following Synappx™ Terms of Use, as well as the <a tabindex="-1" class="text_underline"
          [href]="privacyUrl" target="_blank"><b>Synappx Privacy Policy</b></a> incorporated herein by reference
          (collectively, the “Agreement”), is between Sharp Corporation (“Sharp”) and Customer. This Agreement governs
          access to and use of the Synappx, as well as any Services accessible via Synappx. For purposes of this
          Agreement, the term “Synappx” shall mean Synappx Go, Synappx Admin Portal and related
          Documentation; the term “Services” shall mean the Synappx Services, Specific Software Services and all
          related Documentation which may be proprietary to Sharp and/or third party service providers (“Third Party
          Service Providers”) and which are accessible via the Synappx Service.
        </div>
      </div>
    }
    @if (showSCPToU) {
      <div mat-dialog-content>
        <div class="eula_points"><b>EFFECTIVE: 11/07/2023</b></div>
        <div class="eula_points">
          The following Synappx™ Terms of Use, as well as the <a tabindex="-1" class="text_underline"
          [href]="privacyUrl" target="_blank"><b>Synappx Privacy Policy</b></a> incorporated herein by reference
          (collectively, the “Agreement”), is between Sharp Corporation (“Sharp”) and Customer. This Agreement governs
          access to and use of the Synappx, as well as any Services accessible via Synappx. For purposes of this
          Agreement, the term “Synappx” shall mean Synappx Go, Synappx Cloud Print, Synappx Admin Portal and related
          Documentation; the term “Services” shall mean the Synappx Services, Specific Software Services and all
          related Documentation which may be proprietary to Sharp and/or third party service providers (“Third Party
          Service Providers”) and which are accessible via the Synappx Service.
        </div>
      </div>
    }
    <div class="eula_points">
      Use of the Services is intended for organizations (“Customer”) and their End User(s). The term “End User(s)”
      and its variations shall mean anyone accessing services provided by Synappx Service and may include, but is
      not limited to, Customer’s employees, representatives, contractors, agents or any other individual using or
      accessing the Services under a Customer Account and authorized by the Customer to use the Services. All
      references to the term “Customer” shall also refer to Customer’s authorized Administrator(s) and any of its
      End Users, whether individually or collectively.
    </div>
    <div class="eula_points">
      Prior to any use and before access is granted to the Customer, the authorized Administrator(s) for the
      Customer must agree to this Agreement on behalf of Customer. By clicking “Agree”, you, the Administrator,
      represent and warrant that: 1) you have been designated by the Customer as an “Administrator” and are
      entitled to all rights and privileges afforded to those in the Administrator role (more fully described
      below); 2) you have authority to bind the Customer to this Agreement. If you have not been designated as an
      Administrator for Customer or do not have the authority listed above, you may not click “Agree”, and
      Customer may not use or access the Services. Upon clicking “Agree”, Customer shall have the right to use and
      access the Services subject to the terms set out herein.
    </div>
    <div class="eula_points">
      There may be other specific software services (“Specific Software Services”) accessible within or through
      the Synappx Admin Services that allow Customer to perform certain functions or use additional services and
      features; these Specific Software Services are proprietary to Sharp and/or Third Party Service Providers.
      Customer understands that use and/or access to these Specific Software Services may require Customer,
      Administrator(s) and/or End Users to agree to additional terms and conditions applicable to the use of
      and/or access to the Specific Software Services (“Additional Terms”). If Customer, Administrator(s) and/or
      End Users do not agree to such terms or do not have authority to agree to such Additional Terms, those
      Specific Software Services may not be used or accessed by Customer, Administrator(s) and/or End Users, as
      applicable. In the event of any inconsistency between this Agreement and Additional Terms, the Additional
      Terms shall control but only for that Specific Software Service.
    </div>

    <div>
      <div class="eula_points">
        <b>A. Definitions</b> <br />
        In addition to all defined terms set out above, the following definitions apply to this Agreement:
        <ol>
          <li> <b>Customer Account:</b> Refers to all accounts under or assigned to a
          Customer. This includes all applicable Administrator Accounts as well as any Services licensed
        to and information, data, associated with Customer, Administrator(s) and its End Users.</li>
        <li> <b>Administrator:</b> The employee(s) designated by the Customer to
        manage the information and data associated with the Customer Account, as well as access to and
      licenses for Services on behalf of Customer.</li>
      <li> <b>Administrator Account:</b> This refers to the administrator's
    account.:</li>
    <li> <b>Customer Data:</b> Any data, information stored, transmitted,
    processed or accessed via the Services by Customer, Administrator(s) and/or its End Users or
  associated with a Customer Account.</li>
  <li> <b>Dealer:</b> The authorized reseller of the Services to Customer;
  the Dealer may be Sharp, its subsidiary, or its subsidiary’s direct dealer branches (in the case
  of direct sales to a Customer) or an authorized third party reseller of Sharp products and
  services. The Dealer is also the main contact for Customer for support issues related to the
  Services. The Dealer may provide services for Customer pursuant to an agreement with Customer
and/or Administrator.</li>
<li> <b>Documentation:</b> Any and all installation and user guides, help
files, FAQs related to access or use of the Services.</li>
<li> <b>Intellectual Property Rights:</b> Any current or future worldwide
rights under patent, copyright, trade secret, trademark, moral rights, and other intellectual
property rights.</li>
</ol>
</div>
<div class="eula_points">
  <b>B. Customer Use and Responsibilities </b>
  <ol>
    <li> Customer is responsible for designating which individual(s) are authorized to and will take on
      the role of Administrator on behalf of the Customer. Administrator Accounts may be assigned and
    re-assigned by Customer.</li>
    <li> Customer is responsible for: managing access to Administrator Accounts and ensuring access to
      and/or use of the Services by Customer, Administrator(s) and End Users complies with this
      Agreement, Additional Terms and any applicable Documentation. Sharp and Dealer are not
      responsible for the internal management, administration or use of the Services on behalf of
    Customer.</li>
    <li> Customer understands and agrees that its Administrator(s) and End Users are governed by and
      will abide by this Agreement, the Additional Terms, Documentation and any applicable laws, rules
      and regulations relating to use of the Services. Customer shall be solely responsible for all
      acts or omissions of Customer, its Administrator(s) and End Users or their failure to comply
      with the terms of this Agreement, Additional Terms, Documentation or any applicable laws, rules
      and regulations relating to use of the Services. This responsibility extends to all activities
      under a Customer Account, regardless of whether the activities are undertaken by Customer, its
      employees or a third party (including, but not limited to, Customer’s contractors,
    representatives or agents).</li>
    <li> Customer is responsible for ensuring Administrator(s) and End Users comply with any applicable
      employment obligations and terms and policies of Customer as such pertain to access to and use
    of the Services.</li>
    <li> Customer agrees to secure and maintain all applicable consents from End Users to allow
      Administrators to engage in all activities described in this Agreement and to allow Sharp and/or
    Third Party Service Providers to provide the Services.</li>
    <li> Customer is responsible for and must prevent unauthorized access to and/or use of Services by
      Customer, Administrator(s) and End Users and any third parties. Customer will immediately notify
      Sharp and Dealer of any unauthorized access and/or use of Services. Sharp and Dealer will not be
    responsible for any unauthorized use of or access to Customer Accounts.</li>
    <li> Customer will only use the Services for its own internal business operations, and not for the
      operation of a service bureau or timesharing service. Customer shall not knowingly or willfully
      use or allow use of the Services in a manner that could damage, disable, overburden, impair or
      otherwise interfere with the provision of Services; this includes, but is not limited to, use of
      the Services to transmit viruses or corrupt files which could impair the integrity and security
    of the Services in any way.</li>
    <li> Customer will not and will ensure that its Administrator(s) or End Users do not, directly or
      indirectly: (a) reverse engineer, decompile, disassemble or otherwise attempt to discover the
      source code, object code or underlying structure, ideas or algorithms of the Services or any
      software, Documentation or data related to or provided with or through the Services; (b) modify,
      translate, or create derivative works based on the Services; or copy (except for archival
      purposes), rent, lease, distribute, sell, resell, pledge, assign, or otherwise transfer or
      encumber rights in or to the Services; (c) use or access the Services to build or support,
      and/or assist a third party in building or supporting, products or services competitive to the
    Services; or (d) remove or change any proprietary notices or labels from the Services.</li>
    <li> Customer further will not and will ensure that its Administrator(s) or End Users do not: (a)
      use the Services for activities where use or failure of the Services could lead to physical
      damage, personal injury or death; (b) use the Services or allow use of the Services for illegal,
      fraudulent, offensive or harmful activities; (c) use the Services in a manner that could damage,
      disable, overburden, impair or otherwise interfere with the provision of Services, including
      through sending viruses or corrupt files; or (d) use the Services to infringe or misappropriate
    the Intellectual Property Rights or proprietary rights of others.</li>
    <li> Customer understands that Customer is responsible for complying with any applicable vertical or
      industry-specific regulation compliance, and that Sharp, Dealer and/or Third Party Service
    Providers shall not have any liability for failure of Customer to do so.</li>
    <li> Customer shall be solely responsible for obtaining and maintaining appropriate equipment and
      ancillary services needed to connect to, access, provide or otherwise use the Services,
      including, without limitation, computers, computer operating system(s) and web browser(s),
      Internet access, mobile devices, multi-function peripheral devices (“MFPs”), display systems,
      other electronic devices and accessories (collectively, “Equipment”). Customer shall ensure that
      the Equipment complies with all configurations and specifications set forth in the
      Documentation, if any, for the Services. Documentation related to Specific Software Services may
    be accessible via the Specific Software Services.</li>
    <li> In the event that Customer has a subscription agreement in place with a Dealer or a Third Party
      Service Provider regarding the Services, or any portion thereof, Customer shall ensure that it
      complies with such agreement, including payment of all applicable fees, as failure to do so may
      result in suspension or termination of the Customer Account or access to and use of the
    Services, or a portion thereof.</li>
    <li> In the event there is a valid subpoena, court order or other request received by Customer
      related to the Services, a Customer Account or Customer Data, Customer shall be responsible for
      responding to such requests via access to its own Customer Data. Should Customer not be able to
      access the requested Customer Data or other information requested, Customer shall contact Sharp
      for assistance and Sharp shall make commercially reasonable efforts to assist Customer in this
      regard. If Customer fails to promptly respond, Sharp may respond to such third party request,
      but shall not be required to respond. In the event there is a valid subpoena, court order or
      other request received by Sharp, Dealer and/or a Third Party Service Provider related to the
      Services, a Customer Account or Customer Data, including, but not limited to, Administrator
      Accounts or any data within the Customer Account, Sharp, Dealer and/or a Third Party Service
      Provider shall comply with such subpoena, court order or request as may be required by
      applicable law. Additional information related to Sharp’s use of or potential necessary access
      to Customer Accounts is outlined in the <a tabindex="-1" class="text_underline"
      [href]="privacyUrl" target="_blank"><b>Synappx Privacy Policy</b></a>.</li>
      <li> Customer shall be responsible for any breach of this section by Customer, including any of its
        Administrator(s) or End Users. Customer acknowledges and understands that Sharp, Dealer and
        Third Party Service Providers shall have no liability to Customer or otherwise for any actions
      taken by an End User.</li>
    </ol>
  </div>
  <div class="eula_points">
    <b>C. Administrator Role</b>
    <ol>
      <li> All Administrators must use the Services in accordance with this Agreement, Additional Terms,
        Documentation, if applicable, any and all Customer employment obligations and terms and
        policies, as well as all laws, rules and regulations applicable to access to and/or use of the
      Services.</li>
      <li> Administrator understands that additional Administrator Accounts may be assigned and
      re-assigned by Customer.</li>
      <li> Using the Synappx Admin account, an Administrator maintains control over the Customer Account
        through managing the Customer Account, including any licenses (individual or bundled) associated
      with the Customer Account.</li>
      <li> The Administrator may set-up, grant access, monitor, restrict, suspend and terminate access to
        all Customer Accounts, including additional Administrator Accounts, Workspace licenses or
      End-User Licenses.</li>
      <li> Administrator(s) may also be an End User, in which case all terms in this Agreement or
        Additional Terms related to an End User shall also apply to the Administrator in its capacity as
      an End User.</li>
    </ol>
  </div>
  <div class="eula_points">
    <b>D. End User Use</b>
    <ol>
      <li> Customer shall ensure that End Users use the Services in accordance with this Agreement,
        Additional Terms, Documentation, if applicable, any and all Customer employment obligations and
        terms and policies, as well as all laws, rules and regulations applicable to access to and/or
      use of the Services.</li>
      <li> Customer is responsible for End Users’ access to and use of Services.</li>
      <li> An End User may not disassociate his or her activity in Services from the Customer.</li>
      <li> Customer represents and warrants that: (a) End User has all rights and licenses to access and
        use the Services; and (b) that the storage, transmission, processing of any information related
        with and access of the End User to Services does not violate the terms of this Agreement,
        Additional Terms, relevant Documentation, the Intellectual Property Rights or proprietary rights
      of others, or any applicable laws, rules or regulations.</li>
      <li> Customer acknowledges that it is solely responsible for the nature, quality and accuracy of any
      End User activity in connection with Services.</li>
    </ol>
  </div>
  <div class="eula_points">
    <b>E. Dealer Role</b>
    <ol>
      <li> The Dealer is responsible for setting up a Customer Account and providing licenses for Services
        to the Administrator(s). Once an Administrator for Customer is created, the Dealer will not have
      any ability to create Administrator Accounts.</li>
      <li> Dealers can manage licenses for Customer Accounts, including purchasing or ceasing a license. A
        Dealer will not be able to cease any license which has already been provided to the
      Administrator unless otherwise expressly provided in this Agreement.</li>
      <li> Dealers will have access to basic information regarding Customer Accounts, as well as the
        Customer name, address, phone numbers, and the names and email addresses for all
        Administrator(s). Dealers will also have access and be able to view all Customer Account
      licenses to Services.</li>
      <li> Dealers can suspend and/or cancel a Customer’s access to the Customer Account.</li>
      <li> In the event your Dealer is unable or no longer authorized to service a Customer Account, Sharp
        or its subsidiary may transfer the Customer Account to another Dealer in their sole discretion.
      A Dealer is unable to transfer a Customer Account to another Dealer on its own.</li>
      <li>Dealer can use the Services as the End User at the request of Customer.</li>
    </ol>
  </div>
  <div class="eula_points"><b>F. Services</b>
  <ol>
    <li> Customers may only access and use the Services in accordance with the terms of this Agreement,
      Additional Terms, Documentation and any additional terms of use or privacy policy applicable to
      access to and/or use of the Services. Failure of Customer to comply with this Agreement,
      Additional Terms, Documentation and any applicable laws, rules or regulations may lead to such
      Customer Account or Administrator Account being suspended or terminated in Sharp’s sole
    discretion.</li>
    <li> Services or portions thereof may be subject to subscription agreements with Dealers and/or
      Third Party Service Providers; failure of Customer to comply with such agreements, including,
      but not limited to, payment of all applicable fees, may result in the suspension or termination
      of the Customer Account or access to and use of the Services, or a portion thereof, as a result
    of such failure.</li>
    <li> Access to and use of the Services is also subject to Sharp’s receipt of all fees from the
      Dealer for Customer’s access to and use of the Services; in the event Sharp, or its subsidiary,
      has not received any fees applicable to your Customer Account from your Dealer, and such failure
      is not remedied within thirty (30) days of written notice thereof; Sharp, or its subsidiary,
      may, in their sole discretion, suspend or terminate your Customer Account until such time as
    Sharp, or its subsidiary, receives such payments due.</li>
    <li> Sharp will use commercially reasonable efforts to ensure that all facilities used to store and
      process Customer Data meet commercially reasonable security standards. By using the Services,
    Customer consents to the transfer, processing and storage of Customer Data by Sharp.</li>
    <li> Customer understands that Sharp and/or Third Party Service Providers may update the Services
    from time to time with or without notice to Customer.</li>
    <li> Notwithstanding anything to the contrary, in the event it is determined that Customer Data
      violates or may violate this Agreement or impairs, overburdens or may threaten or cause damage
      to the Services in any way, such Customer Data may be deleted, in whole or in part, at Sharp’s
      sole discretion, with or without notice to Customer and without any Sharp’s liability
      whatsoever. Customer shall be responsible for ensuring Customer Data is backed-up in the event
    of such deletion.</li>
    <li> Additional terms related to privacy, processing and storage of Customer Data, as well as access
      to Customer Accounts are set out in the <a tabindex="-1" class="text_underline"
      [href]="privacyUrl" target="_blank"><b>Synappx Privacy Policy</b></a> and applicable
    Documentation for the Services.</li>
  </ol>
</div>
<div class="eula_points"><b>G. Support</b>
<ol>
  <li> Customer is responsible for contacting Dealer for any support issues related to the Services
  which cannot be addressed via the Documentation for Specific Software Services.</li>
  <li> Unless Sharp or a Sharp dealer branch is the Dealer for your Customer Account, Sharp is not
    responsible to Customer for any questions related to or support of the Services above and beyond
  what is provided via the Documentation for Specific Software Services.</li>
</ol>
</div>
<div class="eula_points"><b>H. Intellectual Property</b>
<ol>
  <li> This Agreement does not grant Sharp, Dealer or any Third Party Service Provider any rights to
    Customer Data or the intellectual property rights embodied in any Customer Account,
    Administrator Account, except for the limited rights expressly set forth in this Agreement or
    Additional Terms or which are otherwise needed to provide the Services and allow Customer to use
  the Services.</li>
  <li> Unless otherwise specifically set forth in this Agreement or the Additional Terms, there is no
    grant to Customer, Administrator(s) or any End Users of: (a) any Intellectual Property Rights in
    or to the Services or any portion thereof; (b) any Intellectual Property Rights in or to any
    other Customer Accounts; or (c) any rights to use the logos, trademarks, service marks, domain
    names or branding features of Sharp, Dealer, Third Party Service Providers, the Services or any
  component of the Services.</li>
  <li> To the extent Sharp is requested by Customer, Administrator(s) or an End User for certain
    actions, including, but not limited to, transmitting, hosting or sharing files, utilizing or
    granting access to product features or settings, then Customer grants Sharp the permission to
    perform all actions necessary for Sharp or Dealer to provide the Services and functionality
    available via the Services and as may be outlined in the Documentation. This permission extends
  to any services of Third Party Providers Sharp uses to provide the Services.</li>
</ol>
</div>

<div class="eula_point">
  <div><b>I. Disclaimers</b></div>
  <div class="eula_point_left">SHARP WILL MAKE COMMERCIALLY REASONABLE EFFORTS TO MAKE THE SERVICES
    AVAILABLE FOR CUSTOMER’S USE AND ACCESS IN ACCORDANCE WITH THIS AGREEMENT, ADDITIONAL TERMS AND ANY
    APPLICABLE DOCUMENTATION. NOTWITHSTANDING ANYTHING TO THE CONTRARY, THE SERVICES ARE PROVIDED “AS
    IS”. TO THE FULLEST EXTENT PERMITTED BY LAW, EXCEPT AS EXPRESSLY STATED HEREIN, SHARP MAKES NO
    WARRANTY OF ANY KIND ON BEHALF OF ITSELF, DEALER OR ANY THIRD PARTY PROVIDERS, WHETHER EXPRESS,
    IMPLIED OR OTHERWISE, INCLUDING ANY WARRANTIES THAT SERVICE WILL BE UNINTERRUPTED, ERROR-FREE, THAT
    CONTENT WILL BE SECURE OR NOT OTHERWISE LOST OR DAMAGED, THAT DEFECTS WILL BE CORRECTED, OR OF
    MERCHANTABILITY, FITNESS FOR A PARTICULAR USE OR NON-INFRINGEMENT. SHARP MAKES NO REPRESENTATIONS
    ABOUT ANY CONTENT, INCLUDING ANY CUSTOMER DATA IN OR FROM A CUSTOMER ACCOUNT AND CUSTOMER SHALL BE
  SOLELY RESPONSIBLE FOR ALL CUSTOMER DATA, AS WELL AS ACCESS TO AND USE OF THE SERVICES.</div>
</div>

<div class="eula_points"><b>J. Term and Termination</b>
<ol>
  <li> This Agreement will remain in effect until Customer no longer has a valid subscription or
    access to the Services, or until this Agreement is terminated in accordance with the terms set
    out in this Agreement. Customer understands that certain Specific Software Services may
  terminate sooner in accordance with the provisions of any applicable Additional Terms.</li>
  <li> Dealer may terminate a Customer Account in the event that Customer does not pay any
  subscription fees due to Dealer for Customer’s use of or access to the Services.</li>
  <li> Sharp may terminate this Agreement and your access and use of the Services in the event that
    Sharp does not receive fees from Dealer for Customer’s use or access to the Services and such
    failure is not remedied within thirty (30) days of written notice thereof; such suspension or
  termination may continue in effect until such time Sharp receives such payments due.</li>
  <li> This Agreement and access and use of the Services shall automatically renew unless Customer
  notifies Dealer of its intent to terminate the Services.</li>
  <li> In addition, Sharp, or its subsidiary, may terminate this Agreement if Customer breaches any
    material term of this Agreement and does not remedy the breach within thirty (30) days after
    receipt of written notice of the breach; such written notice may take the form of an email or
  other electronic notification.</li>
  <li> In the event of any termination of this Agreement, the rights granted to Customer,
    Administrator(s) and End Users shall cease immediately, except that the Customer Account and
    Customer Data under a Customer Account will be accessible for fifteen (15) days following the
    effective end date of subscription. Upon expiration or termination of this Agreement for any
    reason, except as explicitly authorized under this Section, Customer agrees to immediately
    terminate all access to and use of the Services. Customer acknowledges and agrees that Sharp
    and/or Third Party Service Providers shall have no obligation to retain Customer Data following
    the thirty (30) day period referred to herein and that following this thirty (30) day period,
  all Customer Data may be irretrievably deleted.</li>
  <li> Notwithstanding any termination or expiration of this Agreement, Customer shall still remain
    responsible for any fees which may be due to Dealer pursuant to your agreement with your Dealer
    or which may be otherwise due to Dealer for any use or access to the Services prior to the
  effective date of termination or expiration of this Agreement.</li>
  <li> Notices to Customer under this section may take the form of an email or other electronic
  notification and may be directed to the Administrator(s).</li>
  <li> The following sections of this Agreement shall continue in effect following the expiration or
    termination of this Agreement for any reason: Sections F(6), H, I, J(6) through J(9), K, L, M, Q
  and S.</li>
  <li> The 1 to 9 of this Article J (Term and Termination) are not applied for Synappx Manage. Synappx
    Manage may terminate
    your free use at any time and for any reason at Sharp's sole discretion, without liability to
  you.</li>
</ol>
</div>
<div class="eula_point">
  <div><b>K. Indemnification</b></div>
  <div class="eula_point_left">Customer will indemnify, defend and hold harmless Sharp, its Dealers, Third
    Party Service Providers, and each of their affiliates, including but not limited to parent
    corporations or subsidiaries, directors, officers, employees, agents and contractors (collectively,
    “Sharp Parties”) from and against all liabilities, damages and costs (including settlements costs
    and reasonable attorneys’ fees) arising out of a third party claim regarding: (a) use of the
    Services by Customer; (b) all Customer Data; (c) any breach or violation of this Agreement by
    Customer, Administrator(s) and/or an End User; and (d) any violation or alleged violation of any
    applicable laws, rules or regulations applicable to Customer, Administrator and/or an End User with
    regard to the Services. Sharp will take commercially reasonable steps to notify Customer of any such
  claim or demand subject to this section.</div>
</div>

<div class="eula_point">
  <div><b>L. Limitation of Liability</b></div>
  <div class="eula_point_left">TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT WILL THE SHARP PARTIES
    BE LIABLE TO CUSTOMER, ADMINISTRATOR(S), END USERS OR ANY THIRD PARTY FOR ANY DIRECT, SPECIAL,
    INCIDENTAL, INDIRECT, PUNITIVE OR CONSEQUENTIAL DAMAGES, INCLUDING, BUT NOT LIMITED TO, LOSS OF
    PROFITS, DATA, USE OR CONTENT OR OTHER LOSS ARISING OUT OF OR RELATING TO THIS AGREEMENT, ADDITIONAL
    TERMS, THE SERVICES, THE CUSTOMER ACCOUNT OR CUSTOMER DATA. THIS PARAGRAPH SHALL APPLY REGARDLESS OF
    WHETHER THE THEORY OF LIABILITY IS BASED ON CONTRACT, TORT, NEGLIGENCE, BREACH OF WARRANTY, STRICT
    LIABILITY OR OTHERWISE AND WHETHER OR NOT THE SHARP PARTIES HAVE BEEN ADVISED ABOUT THE POSSIBILITY
    OF SUCH DAMAGES. IN NO EVENT SHALL THE SHARP PARTIES’ CUMULATIVE LIABILITY TO CUSTOMER OR ANY THIRD
    PARTY BE GREATER THAN AN AMOUNT EQUAL TO THREE MONTHS OF YOUR SERVICE FEE. YOU HEREBY RELEASE THE
    SHARP PARTIES FROM ANY AND ALL OBLIGATIONS, LIABILITIES AND CLAIMS IN EXCESS OF THIS LIMITATION.
    THIS LIMITATION OF LIABILITY SHALL SURVIVE THE EXPIRATION OR TERMINATION OF THIS AGREEMENT FOR ANY
    REASON AND APPLY EVEN IF ANY LIMITED REMEDY SPECIFIED IN THIS SECTION IS FOUND TO HAVE FAILED OF ITS
  ESSENTIAL PURPOSE.</div>
</div>

<div class="eula_point list_custom">
  <div><b>M. Governing Law/Waiver of Jury Trial</b></div>
  <div class="eula_point_left">If Customer uses the Services for only personal non-business purposes, then
    this Agreement will be governed by the laws
  of the jurisdiction in which Customer purchased or obtained the license to use the Services.</div>
  <div class="eula_point_left">If
    Customer is not such a consumer, this Agreement will be governed by and construed in accordance with
    the substantive
  laws in force in:</div>
  <ol>
    <li>the State of New York, if a license to use the Services is purchased or obtained when the
      Customer is in the United
    States, Canada, or Mexico;</li>
    <li>England and Wales, if a license to use the Services is purchased or obtained when the Customer
      is in the United Kingdom
    or in any EEA country;</li>
    <li>the European Union country the Customer is in, if a license to use the Services is purchased or
      obtained by the Customer
    in that European Union country;</li>
    <li>Japan, if a license to use the Services is purchased or obtained when the Customer is in any
      jurisdiction not described
    above;</li>
  </ol>
  <div class="eula_point_left">The respective competent courts of:</div>
  <ol>
    <li>New York County, New York when New York law applies;</li>
    <li>England and Wales, when the law of England and Wales applies;</li>
    <li>the European Union country of the Customer when the law of that country of the European Union
    applies;</li>
    <li>Osaka District Court in Japan, when Japanese law applies
    </li>
    shall each have non-exclusive jurisdiction over all disputes relating to
    this Agreement.
  </ol>
  <div class="eula_point_left">Any
    claims under this Agreement against Sharp Parties must be brought
    within one (1) year after the cause of action
    arises or the claim or cause of action is barred. Customer and Sharp hereby waive trial by jury
    with
    respect to any
  dispute relating to this Agreement or the Services.</div>
</div>

<div class="eula_point">
  <div><b>N. Trademarks</b></div>
  <div class="eula_point_left">The trademarks or service marks “SHARP”, “Synappx”, ”Synappx Meeting”,
    ”Synappx Go”, or any other related product names, service names or logos used, quoted and/or
    referenced on or through the Services are trademarks, registered trademarks or service marks of
    Sharp and/or its affiliated entities. All other product, service names, logos and/or company names
    appearing on or through the Services are the property of their respective holders and may be
  protected as their trademarks, registered trademarks, service marks and/or trade names.</div>
</div>

<div class="eula_point">
  <div><b>O. Force Majeure</b></div>
  <div class="eula_point_left">The Sharp Parties, Third Party Services Providers and Customer will not be
    liable for inadequate performance to the extent caused by a condition that was beyond that party’s
    reasonable control, including, but not limited to, natural disaster, act of war, terrorism or
    hostility, riot, governmental action, labor conditions or electric, telecommunications or Internet
    disturbances or failures. Sharp and Customer agree to use reasonable efforts to mitigate the effects
  of any force majeure event.</div>
</div>

<div class="eula_point">
  <div><b>P. Export</b></div>
  <div class="eula_point_left">Customer agrees that local (to the country of use of the Services) export
    control laws govern your use of the Services (including technical data) and any deliverables from
    access to and use of the Services, and Customer agrees to comply with all such export laws and
    regulations (including “deemed export” and “deemed re-export” regulations). Customer agrees that no
    data, information, software programs and/or materials resulting from the Services (or direct product
    thereof) will be exported, directly or indirectly, in violation of these laws, or will be used for
    any purpose prohibited by these laws, including, without limitation, nuclear, chemical, or
  biological weapons proliferation, or development of missile technology.</div>
</div>

<div class="eula_point">
  <div><b>Q. Statistical Information</b></div>
  <div class="eula_point_left">Notwithstanding anything else in this Agreement or otherwise, Sharp may
    monitor Customer’s use of the Services and use Customer Data in an aggregate and anonymous manner,
    compile statistical, use and performance information related to the provision and operation of the
    Services, and may make such information publicly available (“Aggregated Data”), provided that such
    Aggregated Data does not identify Customer or disclose Customer Data. Sharp retains all Intellectual
  Property Rights in such Aggregated Data.</div>
</div>

<div class="eula_points"><b>R. Terms Modification</b>
<ol>
  <li> Sharp may revise or modify the terms of this Agreement from time to time in its sole
    discretion. In the event these terms are revised or modified, Administrator(s) shall be required
    to accept the revised or modified terms at the first log-in following the effective date of such
    revision or modification. The current version of this Agreement will be posted on <a
    tabindex="-1" class="text_underline" [href]="termsUseUrl" target="_blank">Synappx Support
  Site</a> and Customer is responsible for checking the site on a regular basis. Sharp will
  make reasonable efforts to provide thirty (30) days notice prior to the effective date of a
change, but some changes may be effective with less than thirty (30) days notice.</li>
<li> If Customer continues using the Services after the effective date of the revised or modified
  Agreement, Customer agrees that it, its Administrator(s) and its End Users will thereafter be
  bound by the new terms. If Customer does not agree to the revised Agreement terms, Customer may
choose to cease accessing to and using the Services.</li>
</ol>
</div>
<div class="eula_points"><b>S. Additional Terms</b>
<ol>
  <li> Customer agrees that there is no partnership, joint venture or agency relationship between
  Sharp and Customer.</li>
  <li> Unless Customer specifically advises Sharp otherwise in writing, Sharp may include Customer’s
  name in a list of customers on Sharp’s marketing materials, including web sites.</li>
  <li> Except as otherwise specified in this Agreement, general notices from Sharp to Customer or End
    Users relating to this Agreement or the Services shall be posted on <a tabindex="-1"
  class="text_underline" [href]="supportType" target="_blank">Synappx Support Site</a>.
  Customer and End Users should therefore regularly visit <a tabindex="-1" class="text_underline"
[href]="supportType" target="_blank">Synappx Support Site</a> in order to be aware of any
such notices. Specific notices regarding Services will go to the Administrator's e-mail on
record. Any notices including legal notices, questions or comments related to this Agreement
should be directed to: <br>
<span>Synappx Product Manager</span>
<div>Sharp Corporation </div>
<div>492 Minosho-cho, Yamato-Koriyama City, </div>
<div>Nara 639-1186, Japan</div>
</li>
<li> Customer may not assign or transfer any part of this Agreement without the prior written
  consent of Sharp. Sharp may assign this Agreement upon providing notice to Customer, which may
  take the form of an email, posting or message via the Services. Notwithstanding anything to the
  contrary, Sharp may assign this Agreement to an affiliated entity or in connection with a
  merger, acquisition, corporate reorganization, or sale of all or substantially all of its assets
without providing any notice to Customer.</li>
<li> Sharp’s waiver of any breach or right under this Agreement shall not be deemed a waiver of any
other or subsequent breach or right.</li>
<li> If any provision of this Agreement (or part thereof) is found unenforceable or contrary to law,
  it will be modified to the least extent necessary to make it enforceable, and the remaining
portions of this Agreement will remain in full force and effect.</li>
<li> This Agreement and the Additional Terms, if any, constitute the entire agreement between
  Customer and Sharp with respect to the Services and supersedes and replaces any prior or
  contemporaneous understandings and agreements, including purchase orders, whether written or
oral, with regard to the subject matter of this Agreement.</li>
</ol>
</div>
</div>
</div>
<div mat-dialog-actions>
  <button mat-button class="primary_btn" (click)="agreeClick()" id="eula-id-agree-button"
  name="eula-name-agree-button">{{"Agree" |translate}}</button>
  <button #eulaCancelButton mat-button (click)="onCancel()" class="secondary_btn" id="eula-id-cancel-button"
  name="eula-name-cancel-button">{{"Decline" |translate}}</button>
</div>
</div>
